export const isResizeObserverSupported = () => window && typeof window.ResizeObserver !== 'undefined';
isResizeObserverSupported;
//# sourceMappingURL=is-resize-observable-supported.js.map